import { render } from "./ImageDeleterFloatingWindow.vue?vue&type=template&id=e718d2bc&scoped=true"
import script from "./ImageDeleterFloatingWindow.vue?vue&type=script&lang=js"
export * from "./ImageDeleterFloatingWindow.vue?vue&type=script&lang=js"

import "./ImageDeleterFloatingWindow.vue?vue&type=style&index=0&id=e718d2bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e718d2bc"

export default script